import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { User } from '../_models/user.model';
import { Permission } from '../_models/permission.model';
import { Role } from '../_models/role.model';
import { catchError, map } from 'rxjs/operators';
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { WebApiService } from '../../_services/WebApiService';



@Injectable()
export class AuthService {
    API_USERS_URL: string;
    API_USERS_URL_LOGIN: string;
    API_PERMISSION_URL: string;
    API_ROLES_URL: string;
    constructor(private http: HttpClient,private webApi:WebApiService) {

            this.API_USERS_URL =    this.webApi.GetApiAddress() +   '/ApplicationUser';  ///Login
            this.API_USERS_URL_LOGIN =    this.webApi.GetApiAddress() +   '/ApplicationUser/Login'; 
            this.API_PERMISSION_URL =  this.webApi.GetApiAddress() +  '/Permissions';
            this.API_ROLES_URL = this.webApi.GetApiAddress() +  '/Permissions/Roles';

    }




    // Authentication/Authorization
    login(email: string, password: string): Observable<User> {


        return this.http.post<User>(this.API_USERS_URL_LOGIN, { UserName : email,Password : password });
    }

    getUserByToken(): Observable<User> {
        const userToken = localStorage.getItem(environment.authTokenKey);


        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
       // httpHeaders.set('Authorization', 'Bearer ' + userToken);

        httpHeaders.set('Authorization', 'Bearer  eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VySUQiOiJlZmI2Njg1Yi01ZGY5LTRiZjAtODY5Ny01ZTBjZTFiN2JmYmIiLCJFbWFpbCI6ImFuZHJlQHNwb2x0aS5jb20uYnIiLCJGdWxsTmFtZSI6IkFuZHJlIFNwb2x0aSIsIm5iZiI6MTU3NTQyNTg3NiwiZXhwIjoxNTc1NTEyMjc2LCJpYXQiOjE1NzU0MjU4NzZ9.OSvwIOx6FWh0IVEdihc_Ek1rLv2793AcicfHb-dZROY');

        return this.http.get<User>(this.API_USERS_URL+"/UserByToken", { headers: httpHeaders })
        .pipe(
            map(user=>
                {
               
                return user
                }),
                catchError(error=>
                    {
                        return of(null);
                    })
        )
    }

    register(user: User): Observable<any> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
        return this.http.post<User>(this.API_USERS_URL+"/register", user, { headers: httpHeaders })
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError(err => {
                    return null;
                })
            );
    }

    /*
     * Submit forgot password request
     *
     * @param {string} email
     * @returns {Observable<any>}
     */
    public requestPassword(email: string): Observable<any> {
       
   
    	return this.http.get(this.API_USERS_URL + '/forgot/' + email)
    		.pipe(catchError(this.handleError('forgot-password', []))
	    );
    }


    getAllUsers(): Observable<User[]> {
		return this.http.get<User[]>(this.API_USERS_URL+"3");
    }

    getUserById(userId: number): Observable<User> {
		return this.http.get<User>(this.API_USERS_URL + `/${userId}`);
	}


    // DELETE => delete the user from the server
	deleteUser(userId: number) {
		const url = `${this.API_USERS_URL}/${userId}`;
		return this.http.delete(url);
    }

    // UPDATE => PUT: update the user on the server
	updateUser(_user: User): Observable<any> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		      return this.http.put(this.API_USERS_URL+"5", _user, { headers: httpHeaders });
	}

    // CREATE =>  POST: add a new user to the server
	createUser(user: User): Observable<User> {
    	const httpHeaders = new HttpHeaders();
     httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<User>(this.API_USERS_URL+"4", user, { headers: httpHeaders});
	}

    // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
	// items => filtered/sorted result
	findUsers(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		      return this.http.post<QueryResultsModel>(this.API_USERS_URL + '/findUsers', queryParams, { headers: httpHeaders});
    }

    // Permission
    getAllPermissions(): Observable<Permission[]> {
		return this.http.get<Permission[]>(this.API_PERMISSION_URL);
    }

    getRolePermissions(roleId: number): Observable<Permission[]> {
        return this.http.get<Permission[]>(this.API_PERMISSION_URL + '/getRolePermission?=' + roleId);
    }

    // Roles
    getAllRoles(): Observable<Role[]> {
        return this.http.get<Role[]>(this.API_ROLES_URL);
    }

    getRoleById(roleId: number): Observable<Role> {
		return this.http.get<Role>(this.API_ROLES_URL + `/${roleId}`);
    }

    // CREATE =>  POST: add a new role to the server
	createRole(role: Role): Observable<Role> {
		// Note: Add headers if needed (tokens/bearer)
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		      return this.http.post<Role>(this.API_ROLES_URL, role, { headers: httpHeaders});
	}

    // UPDATE => PUT: update the role on the server
	updateRole(role: Role): Observable<any> {
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		      return this.http.put(this.API_ROLES_URL, role, { headers: httpHeaders });
	}

	// DELETE => delete the role from the server
	deleteRole(roleId: number): Observable<Role> {
		const url = `${this.API_ROLES_URL}/${roleId}`;
		return this.http.delete<Role>(url);
	}

    // Check Role Before deletion
    isRoleAssignedToUsers(roleId: number): Observable<boolean> {
        return this.http.get<boolean>(this.API_ROLES_URL + '/checkIsRollAssignedToUser?roleId=' + roleId);
    }

    findRoles(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
        // This code imitates server calls
        const httpHeaders = new HttpHeaders();
        httpHeaders.set('Content-Type', 'application/json');
		      return this.http.post<QueryResultsModel>(this.API_ROLES_URL + '/findRoles', queryParams, { headers: httpHeaders});
	}

 	/*
 	 * Handle Http operation that failed.
 	 * Let the app continue.
     *
	 * @param operation - name of the operation that failed
 	 * @param result - optional value to return as the observable result
 	 */
    private handleError<T>(operation = 'operation', result?: any) {
        return (error: any): Observable<any> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // Let the app keep running by returning an empty result.
            return of(result);
        };
    }
}
